export const renderPrivacyPolicyLink = (hostname: string) => {
  if (hostname.includes('bors')) {
    return 'https://finansavisen.no/personvern';
  }

  if (hostname.includes('localhost')) {
    return 'https://finansavisen.no/personvern';
  }

  return `https://${hostname}/personvern`;
};
